import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userReducer from 'store/user/userSlice';
const LEGACY_PERSISTED_USER_STATE_KEY = 'persist:user';
export const removeLegacyPersistedUserState = () => {
    var _a, _b;
    try {
        (_b = (_a = globalThis.localStorage) === null || _a === void 0 ? void 0 : _a.removeItem) === null || _b === void 0 ? void 0 : _b.call(_a, LEGACY_PERSISTED_USER_STATE_KEY);
    }
    catch (_c) {
        // Ignore storage errors
    }
};
removeLegacyPersistedUserState();
const store = configureStore({
    reducer: combineReducers({
        user: userReducer
    })
});
export { store };
